/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'

import CenterCol from '../../center-col'
import ImageFill, { ImageInline } from '../../image'
import Section from '../../section'

import { renderHTML, formatImage, ratioForImage } from '../../../lib/helpers'
import { Cont, FlexCols, FlexCol, FlexColEmpty } from '../../../styles/els'

const ImageBlock = (props) => {
  const { image: _image, display, ...otherProps } = props

  const image = formatImage(_image)

  return (
    <Section full={display === 'full'}>
      {image ? (
        display === 'full' ? (
          <div
            sx={{
              position: 'relative',
              width: '100%',
              height: '580px',
            }}
          >
            <ImageFill image={image} />
          </div>
        ) : (
          <CenterCol span={10}>
            <ImageInline image={image} />
          </CenterCol>
        )
      ) : null}
    </Section>
  )
}

export default ImageBlock
